import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mop-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent {}
